import React from 'react';
import { Form, Radio, Button, Icon, Divider } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';

import styled from 'styled-components';
import { ErrorMessage } from 'formik';

import FormikInputField from '../componentsFormik/FormikInputField';

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class AQPayslip extends React.Component<any, any> {

  fileInputRef: any = React.createRef();

  navigate = (
    step: number | string,
    backStep: (null | number | string) = null,
    percent: (null | number) = null,
    motivation: (null | string) = null,
    e: any,
    props?: any,
    validate?: boolean
  ) => {
    e.preventDefault();

    if (validate) {
      this.props.gaEvent('event', 'UploadPayslip', 'Upload', 'Boots', this.props.isValid);
    }

    this.props.manualStep(step, backStep, percent, motivation, props, validate);
  };

  reInitializeFields = () => {
    [
      'aq_filePayslip',
      'aq_jobTitle',
      'aq_nationalInsurance',
      'aq_dateStarted',
      'aq_dateEnded',
      'aq_jobChangedLastSixYears',
      'aq_maidenName'
    ].map((field) => {
      return this.props.setFieldValue(field, '');
    });
  }

  render() {
    return (
      <React.Fragment>
        <h1>Payslip Upload/Questionnaire</h1>

        <Button.Group widths="2">
          <Button
            color='green'
            content='Complete A Questionnaire Instead'
            onClick={(e) => {
              this.reInitializeFields();
              this.props.setFieldValue('aq_type', 'Questionnaire');
              this.navigate('QUESTIONNAIRE', null, null, null, e, null, false)
            }}
            style={{ marginBottom: '1rem' }}
            type='button'
          />
        </Button.Group>

        <Form.Group grouped>
          <Button
            type='button'
            content="Choose File"
            labelPosition="left"
            icon="file"
            onClick={() => this.fileInputRef.current.click()}
          />
          <input
            name="aq_filePayslip"
            ref={this.fileInputRef}
            type="file"
            hidden
            onChange={(e) => {
              if (e.target && e.target.files && e.target.files.length) {
                this.props.setFieldValue('aq_filePayslip', e.target.files[0]);
              }
            }}
          />

          <ErrorMessage
            name={'aq_filePayslip'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <FormikInputField
          name="aq_jobTitle"
          type="input"
          label="Job Title"
          placeholder=""
        />

        <FormikInputField
          name="aq_nationalInsurance"
          type="input"
          label="NI Number"
          placeholder="QQ 12 34 56 C"
          data-testid="pd-input-ni"
        />

        <Form.Group grouped>
          <DateInput
            label="Date Started"
            id="aq_dateStarted"
            clearable
            clearIcon={<Icon name="remove" color="red" />}
            name="aq_dateStarted"
            value={this.props.values.aq_dateStarted}
            onChange={(e, { name, value }) => {
              this.props.setFieldValue(name, value);
            }}
            onBlur={this.props.handleBlur}
            placeholder="dd/mm/yyyy"
            dateFormat="DD/MM/YYYY"
            animation={'fade'}
            autoComplete="off"
            closable={true}
            startMode="year"
            popupPosition="bottom center"
            hideMobileKeyboard={true}
          />
          <ErrorMessage
            name={'aq_dateStarted'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <Form.Group grouped>
          <DateInput
            label="Date Ended"
            id="aq_dateEnded"
            clearable
            clearIcon={<Icon name="remove" color="red" />}
            name="aq_dateEnded"
            value={this.props.values.aq_dateEnded}
            onChange={(e, { name, value }) => {
              this.props.setFieldValue(name, value);
            }}
            onBlur={this.props.handleBlur}
            placeholder="dd/mm/yyyy"
            dateFormat="DD/MM/YYYY"
            animation={'fade'}
            autoComplete="off"
            closable={true}
            startMode="year"
            popupPosition="bottom center"
            hideMobileKeyboard={true}
          />
          <ErrorMessage
            name={'aq_dateEnded'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <Form.Group grouped>
          <label>Has your job at Boots changed in the last 6 years?</label>
          <Form.Field>
            <Radio
              label="No"
              name="aq_jobChangedLastSixYears"
              value="No"
              checked={this.props.values.aq_jobChangedLastSixYears === 'No'}
              onChange={() => this.props.setFieldValue('aq_jobChangedLastSixYears', 'No')}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Yes (we will ask you to describe your previous job on the next page of the questionnaire)"
              name="aq_jobChangedLastSixYears"
              value="Yes"
              checked={this.props.values.aq_jobChangedLastSixYears === 'Yes'}
              onChange={() => this.props.setFieldValue('aq_jobChangedLastSixYears', 'Yes')}
            />
          </Form.Field>
          <ErrorMessage
            name={'aq_jobChangedLastSixYears'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />

          <Divider />

          <FormikInputField
            name="aq_maidenName"
            type="input"
            label="Maiden Name (if applicable)"
            data-testid="pd-input-maiden-name"
          />

        </Form.Group>


        <Button.Group widths="2">
          <Button
            labelPosition="right"
            floated="right"
            color={this.props.isValid ? 'green' : 'grey'}
            icon="right chevron"
            content={this.props.values.aq_jobChangedLastSixYears === 'No' ? 'Submit' : 'Next'}
            onClick={(e) => {
              let submitOrNext = this.props.values.aq_jobChangedLastSixYears === 'No' ? 'FINALLY' : 'PREVIOUS_JOBS';
              this.navigate(submitOrNext, 'PAYSLIP', null, null, e, this.props, true);
            }}
          />
        </Button.Group>
      </React.Fragment>
    );
  }
}

export default AQPayslip;
